import axios from 'axios';

/**
 * Tag Service
 * Handles organization-scoped tags that can be assigned to deals.
 * The organization is derived from the auth token by the backend.
 */
export const tagService = {
  /**
   * Get all tags for the organization
   * @returns {Promise<Object>} { tags: Tag[] }
   */
  async getTags() {
    try {
      const response = await axios.get('/tags');
      return response.data;
    } catch (error) {
      console.error('Error fetching tags:', error);
      throw error;
    }
  },

  /**
   * Create a new tag
   * @param {Object} tagData - { name, color }
   * @returns {Promise<Tag>}
   */
  async createTag(tagData) {
    try {
      const response = await axios.post('/tags', tagData);
      return response.data;
    } catch (error) {
      console.error('Error creating tag:', error);
      throw error;
    }
  },

  /**
   * Update a tag
   * @param {string} tagId
   * @param {Object} tagData - { name?, color? }
   * @returns {Promise<Tag>}
   */
  async updateTag(tagId, tagData) {
    try {
      const response = await axios.patch(`/tags/${tagId}`, tagData);
      return response.data;
    } catch (error) {
      console.error('Error updating tag:', error);
      throw error;
    }
  },

  /**
   * Delete a tag (also removes it from all deals)
   * @param {string} tagId
   * @returns {Promise<void>}
   */
  async deleteTag(tagId) {
    try {
      await axios.delete(`/tags/${tagId}`);
    } catch (error) {
      console.error('Error deleting tag:', error);
      throw error;
    }
  },
};

export default tagService;
